import './Clients.scss';
import { useNavigate } from 'react-router-dom';
import Logo1 from '../../assets/logo1.png';
import Logo2 from '../../assets/logo2.png';
import Logo3 from '../../assets/logo3.png';
import Logo4 from '../../assets/logo4.png';
import Logo5 from '../../assets/logo5.png';
import Logo6 from '../../assets/logo6.png';
import Logo7 from '../../assets/logo7.png';
import Logo8 from '../../assets/logo8.png';
import Logo9 from '../../assets/logo9.png';

const Clients = () => {
  const navigate = useNavigate();

  return (
    <div className='clients'>
      <div className='clientsContent'>
        <div className='clientsRow'>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo1} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo2} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo3} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo4} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo5} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo6} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo7} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo8} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo9} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo1} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo2} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo3} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo4} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo5} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo6} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo7} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo8} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo9} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo1} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo2} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo3} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo4} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo5} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo6} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo7} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo8} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo9} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo1} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo2} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo3} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo4} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo5} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo6} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo7} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo8} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo9} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo1} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo2} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo3} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo4} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo5} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo6} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo7} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo8} />
            </span>
          </div>
          <div className='client'>
            <span className='clientImage'>
              <img src={Logo9} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
